import { ModalProvider } from '@payright/web-components';
import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

export const ModalProviderReactRouterDom = ({ children }: PropsWithChildren) => {
  const location = useLocation();

  return <ModalProvider getPath={() => location.pathname}>{children}</ModalProvider>;
};
